import React from 'react';
import PanelSection from '../../FormElements/PanelSection';
import DateDataType from '../../DataTable2/DataTypes/DateDataType';

export default class UserCustomData extends React.Component {
	constructor(props) {
		super(props);
	}

	render() {
		const { title, customData, onShowUserCustomDataEditCardPopup } = this.props;

		let hasCustomData = customData && customData.fields;

		let section = null;
		if (hasCustomData) {
			const fieldElements = this.props.customData.fields.map((field, index) => {
				const fieldValue = field.value !== null ? field.value.asString : '-';

				const hideIfNull = field.hideIfNull || false;

				if (hideIfNull && fieldValue === '-') {
					return null;
				}

				return (
					<div className="data-group" key={index}>
						<label>{field.displayName}</label>
						<span>
							{field.type === 'DATE' ? (
								<DateDataType
									value={fieldValue !== '-' ? fieldValue : undefined}
								/>
							) : (
								fieldValue
							)}
						</span>
					</div>
				);
			});

			section = (
				<div className="UserPersonalInfo">
					<PanelSection
						title={title}
						onClickShowPopup={onShowUserCustomDataEditCardPopup}
					>
						<div>{fieldElements}</div>
					</PanelSection>
				</div>
			);
		}

		return (
			<div>
				<div>{section}</div>
			</div>
		);
	}
}
